"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentVisitInfoSchema = void 0;
const zod_1 = require("zod");
exports.ContentVisitInfoSchema = zod_1.z.object({
  /** Автор */
  is_author: zod_1.z.boolean(),
  /** Лайкал */
  is_liked: zod_1.z.boolean(),
  /** Дизлайкал */
  is_disliked: zod_1.z.boolean(),
  /** Прокомментировал */
  is_commented: zod_1.z.boolean(),
  /** Проходил/изучал */
  is_passed: zod_1.z.boolean(),
  /** Дата прохождения */
  passed_at: zod_1.z.string().datetime().or(zod_1.z.date()),
  /** Результат прохождения в очках */
  pass_points: zod_1.z.number(),
  /** Результат прохождения в процентах */
  pass_percent: zod_1.z.number(),
  /** ID прохождения */
  pass_game_id: zod_1.z.string(),
  /** Оценивал */
  is_rated: zod_1.z.boolean(),
  /** Дата оценки */
  rated_at: zod_1.z.string().datetime().or(zod_1.z.date()),
  /** Оценка */
  rate: zod_1.z.number(),
  /** Количество терминов словаря выбраны для изучения */
  selected_terms_count: zod_1.z.number().optional(),
  /** Получен ли доступ к контенту (для НЕ публичных уроков) */
  is_access_granted: zod_1.z.boolean().optional()
});
